module.exports = __webpack_public_path__ + "img/haft-poznan-02.753459e3.jpg";